<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name"></sui-page-header>
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_MDLE')" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select ref="modules"
              :page-id="this.$options.name"
              :selected-md="selectData.moduleCode"
              :selected-smd="selectData.subModuleCode"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_TYPE')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-code-select ref="typeOptions"
              :selected="selectData.T_CMZ_CD_M"
              :pageId="this.$options.name"
              codeId="COD_CDST_TYPE"
              :disabled="false"
              :defaultOption="'all'"
              />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
           <sui-input-label :label="$t('MSG_TXT_NCOMP_DIV')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-code-select ref="nCompOptions"
              :selected="selectData.COD_NCOMP_DIV_CD"
              :pageId="this.$options.name"
              codeId="COD_NCOMP_DIV_CD"
              :disabled="false"
              :defaultOption="'all'"
              />
          </div>       
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_SEARCH_COND')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select ref="searchCondOptions"
              codeId="COD_CD_MGT_SEARCH"
              :page-id="this.$options.name"
              :defaultOption="'all'"
              :selected="selectData.T_CMZ_CD_M"
              style="width:58%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              default
              value
              :disabled="false"
              :clearable="true"
              :readonly="false"
              maxlength="100"
              @keyup.enter="searchCompStatus"
              v-model="searchCondText"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button type="button" class="comm_btn_Reset" @click="reset()">{{$t('MSG_BTN_RESET')}}</sui-button>
          <sui-button type="button" class="comm_btn_Scr" @click="searchCompStatus()" v-permission:read="this.$options.name" >{{$t('MSG_BTN_SEARCH')}}</sui-button>
        </div>
      </div>
      <div class="mrB30"></div>
      <sui-grid ref="grid"
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :columnsresize="true"
        :columnsautoresize="true"
        :autowidth="true"
        :initialPagesize="10"
        :showDisplayCountControl="false"
        @rowselect="onSelectRow"
        width="100%"
      >
        <div class="btn_wrapR">
          <sui-button type="button" class="comm_btn_gridTop  comm_ico_excel" @click="excelDownload()" v-permission:download="this.$options.name" >{{$t('MSG_BTN_EXCEL_DOWN')}}</sui-button>
        </div>
      </sui-grid>
      <div class="mrB30"></div>
      <div class="comm_shut_wrap">
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4>{{$t('MSG_TXT_CDVAL_NCOMP_DTL')}}</h4>
          </div>
          <sui-grid
            ref="grid1"
            :columns="gridColumns1"
            :dataset="'dataset1'"
            :columnsresize="true"
            :columnsautoresize="true"
            :autowidth="true"
            :initialPagesize="5"
            :showDisplayCountControl="false"
            @rowclick="onSelectUncompliant"
         
            width="100%"
          />
        </div>
        <div class="emptybox" />
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4>{{$t('MSG_TXT_CDVAL_DTL')}}</h4>
          </div>
          <sui-grid
            ref="grid2"
            :columns="gridColumns2"
            :dataset="'dataset2'"
            :columnsresize="true"
            :columnsautoresize="true"
            :autowidth="true"
            :initialPagesize="5"
            :showDisplayCountControl="false"
            width="100%"
          />
        </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
  export default {
    name: 'PGE_CMT_00011',
    data() {
      return {
        selectData: {
          moduleCode: { key: '', label: '' },
          subModuleCode: { key: '', label: '' },
          T_CMZ_CD_M: { label: '', key: '' },
          COD_NCOMP_DIV_CD: { label: '', key: ''}
        },
        searchCondText: '',
        codeId:'',
        localdata0: [],
        gridColumns0: [{
          text: this.$t('MSG_TXT_MDLE'),
          datafield: 'moduleName',
          width: 150,
        }, {
          text: this.$t('MSG_TXT_SMDLE'),
          datafield: 'subModuleName',
          width: 150,
        }, {
          text: this.$t('MSG_TXT_CODE_ID'),
          datafield: 'codeId'
        }, {
          text: this.$t('MSG_TXT_CODE_NAME'),
          datafield: 'codeName'
        }, {
          text: this.$t('MSG_TXT_TYPE'),
          datafield: 'codeStructureTypeCode',
          width: 150,
        }, {
          text: this.$t('MSG_TXT_VALID_COMP'),
          datafield: 'noncomplianceYn',
          width: 150,
        }, {
          text: this.$t('MSG_TXT_NCOMP_CNT'),
          datafield: 'codeValidValue',
          width: 150,
        }],
          localdata1: [],
          gridColumns1: [{
            text: this.$t('MSG_TXT_TAB_NM'),
            datafield: 'tableName'
          }, {
            text: this.$t('MSG_TXT_COL_NM'),
            datafield: 'columnPhysicalName'
          }, {
            text:  this.$t('MSG_TXT_NON_COMP_VAL'),
            datafield: 'dataStandardNcompValue',
            width: 150,
          }],
          localdata2: [],
          gridColumns2: [{
            text: this.$t('MSG_TXT_CODE_ID'),
            datafield: 'codeId'
          }, {
            text: this.$t('MSG_TXT_CODE_NAME'),
            datafield: 'codeName'
          }, {
            text: this.$t('MSG_TXT_CD_DTL_NM'),
            datafield: 'codeDetailContent'
          }, {
            text: this.$t('MSG_TXT_VALID_VALUE'),
            datafield: 'codeValue'
        }]
      };
    },
    computed: {},
    watch: {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {
      reset() {
       // this.$refs.modules.reset();
       this.selectData.moduleCode.key='ALL';
        this.selectData.moduleCode.key='ALL';
        this.$refs.typeOptions.reset();
        this.$refs.searchCondOptions.reset();
        this.$refs.nCompOptions.reset();
        this.searchCondText = '';
      },
      searchCompStatus() {
        if (utils.isExistSpecialChar(this.searchCondText) === true) {
          utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
        return;
        } 
        const queryParams = {
          subModuleCode: this.selectData.subModuleCode.key ,
          moduleCode:this.selectData.moduleCode.key ,
          codeStructureTypeCode: this.$refs.typeOptions.currentSelected.codeId || '',
          codeManagementCondition: this.$refs.searchCondOptions.currentSelected.codeId || '',
          codeManagementConditionText: this.searchCondText,
          noncomplianceYn: this.$refs.nCompOptions.currentSelected.codeId || ''
        };
        http.request('PGE_CMT_00011', 'DTS_CMT_00065', {
          query: queryParams,
        }).then(res => {
            this.dataset0.setRawData(res.data);
        });
      },
      excelDownload() {
        const queryParams = {
          subModuleCode: this.selectData.subModuleCode.key,
          moduleCode:this.selectData.moduleCode.key,
          codeStructureTypeCode: this.$refs.typeOptions.currentSelected.codeId || '',
          codeManagementCondition: this.$refs.searchCondOptions.currentSelected.codeId || '',
          codeManagementConditionText: this.searchCondText || '',
          noncomplianceYn: this.$refs.nCompOptions.currentSelected.codeId || ''
        };
        http.request('PGE_CMT_00011', 'DTS_CMT_00066', {
          path: {
          'page-id': 'PGE_CMT_00011',
        },
          query: queryParams,
          responseType: 'arraybuffer'
        }).then((res) => {
          let fileName = "valid_code_compliance_table.xlsx";
          utils.downloadBlob(res, fileName);
        })
      },
      onSelectRow(target){
        let stdObyInspDtTmp = target.args.row.stdObyInspDt; 
        const queryParams = {
          stdObyInspDt:stdObyInspDtTmp
        };
        let codeID = target.args.row.codeId;
        
        this.codeId = target.args.row.codeId;
        this.dataset2.setRawData();
        
        http.request('PGE_CMT_00011', 'DTS_CMT_00067', {
          path: {
             'code-id':  codeID
          },
          query: queryParams,
        }).then(res => {
          this.dataset1.setRawData(res.data);
        }).catch(error => {
          this.confirm(1, error);
        });
      
    },
     
    onSelectUncompliant(target){
     
     console.log("inside uncompliant");  
        http.request('PGE_CMT_00011', 'DTS_CMT_00068', {
          path: {
             'code-id':  this.codeId
          },
        }).then(res => {
          this.dataset2.setRawData(res.data);
        }).catch(error => {
          this.confirm(1, error);
        });
      }
    }
    ,
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [ {
        name: 'moduleCode',
        type: 'string',
        map: 'moduleCode',
      }, {
        name: 'subModuleCode',
        type: 'string',
        map: 'subModuleCode',
      }, {
        name: 'moduleName',
        type: 'string',
        map: 'moduleName'
      }, {
        name: 'subModuleName',
        type: 'string',
        map: 'subModuleName'
      }, {
        name: 'codeId',
        type: 'string',
        map: 'codeId'
      }, {
        name: 'codeName',
        type: 'string',
        map: 'codeName'
      }, {
        name: 'codeStructureTypeCode',
        type: 'string',
        map: 'codeStructureTypeCode'
      }, {
        name: 'noncomplianceYn',
        type: 'string',
        map: 'noncomplianceYn'
      }, {
        name: 'stdObyInspDt',
        type: 'string',
        map: 'stdObyInspDt'
      }, {
        name: 'codeValidValue',
        type: 'string',
        map: 'codeValidValue'
      }]
    },
    {
      id: 'dataset1',
      type: 'local',
      data: 'localdata1',
      datafields: [{
        name: 'tableName',
        type: 'string',
        map: 'tableName'
      }, {
        name: 'columnPhysicalName',
        type: 'string',
        map: 'columnPhysicalName'
      }, {
        name: 'dataStandardNcompValue',
        type: 'string',
        map: 'dataStandardNcompValue'
      }]
    },
    {
      id: 'dataset2',
      type: 'local',
      data: 'localdata2',
      datafields: [{
        name: 'codeId',
        type: 'string',
        map: 'codeId'
      }, {
        name: 'codeName',
        type: 'string',
        map: 'codeName'
      }, {
        name: 'codeDetailContent',
        type: 'string',
        map: 'codeDetailContent'
      }, {
        name: 'codeValue',
        type: 'string',
        map: 'codeValue'
      }]
    }
    ]
 
  };
</script>
<style scoped>
</style>
